/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/order */
/* eslint-disable react/function-component-definition */
/* eslint-disable vars-on-top */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable no-redeclare */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import React, {useState,useEffect} from "react";
import { connect, useSelector,useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import clsx from "clsx";
import BackButton from "../../components/BackButton/BackButton";
import styles from "./Help.module.css";
import { CustomTab, Button, AuthChecker } from "../../atomicComponents";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { withAllowedOperationsProvider } from "../../hocs";
import {
    CustomFormGroup,
  } from "../../components/FormComponents";
  import {
    Grid, 
  } from "@material-ui/core";
  import {
    MESSAGE_TYPE,
    RESOURCE_TYPE,
  } from "../../constants";
  import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
  import DownloadIcon from '@mui/icons-material/Download';
import { setLogin } from "../../redux/features/auth/actions";
import { downloadFileFromUrl } from "../../utils/utils";
import apiService from "../../apis/apiService";


    const ContactUs = () => {

      const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
      const auth = useSelector((state) => state.auth); // useSelector
      const [emailDetails,setEmailDetails] = useState([])
      const history = useHistory();
      const { showPopup } = usePopupManager();
      const dispatch = useDispatch()
      const redirectToApplicationLandingPage = () => {
        history.push("/home");
      };

    
      const getEmailDetails = async () => {
        try {        
          const ress = await apiService.getDynamicEmailDetails({},dispatch);       
          dispatch(setLogin({...auth, recentStatus: ress.status}))        
          setEmailDetails(ress?.data)
        } catch (error) {
          dispatch(setLogin({recentStatus: error.response.status})) 
          console.error("error--> ", error);
        }
      }; 
      useEffect(() => {
        getEmailDetails();
      }, []);
      const transformedData = [
        // Row 1: Display names for Contact and Escalation
        {
          Contact: emailDetails.find(item => item.contact_type === "Contact")?.name,
          Escalation: emailDetails.find(item => item.contact_type === "Escalation")?.name,
        },
        // Row 2: Display emails as mailto links
        {
          Contact: emailDetails.find(item => item.contact_type === "Contact")?.email_id ? (
            <a href={`mailto:${emailDetails.find(item => item.contact_type === "Contact")?.email_id}`}>
              {emailDetails.find(item => item.contact_type === "Contact")?.email_id}
            </a>
          ) : "",
          Escalation: emailDetails.find(item => item.contact_type === "Escalation")?.email_id ? (
            <a href={`mailto:${emailDetails.find(item => item.contact_type === "Escalation")?.email_id}`}>
              {emailDetails.find(item => item.contact_type === "Escalation")?.email_id}
            </a>
          ) : "",
        }
      ];
      const handleDownload = async (filename) => {
        try {
              let getFilename = filename;        
              let payload = {
                "path": getFilename
              }            
              const ress = await apiService.getDocumentView(payload, dispatch);
              if(ress.url){
                downloadFileFromUrl(ress.url, getFilename);
                }
                else{
                 showPopup({
                  type: MESSAGE_TYPE.INFORMATION,
                  contextText: MESSAGE_TYPE.INFORMATION,
                  info: "failed to download",
                });
                 
               }
            }
            catch(error){
              showPopup({
                type: MESSAGE_TYPE.FAILURE,
                contextText: MESSAGE_TYPE.FAILURE,
                info: "Failed",
              });
            }
    
        // };
      };

     const renderManualDetails = () => (
        <>
      <Grid container spacing={0.5} style={{  marginTop: "10px" }}>
          <Grid item xs={3} md={2}>
            <h5>Manuals :</h5>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className={styles.formDiv}>  
          <TableSimple
              tableColumnData={[{"Sr No":"1","User":"Individual User:How to book time","Manuals":<DownloadIcon color="primary" style={{cursor: 'pointer'}} onClick={()=>{handleDownload('Individual User Manual.pdf')}}/>},{"Sr No":"2","User":"Supervisor:How to book time for OP Grade employees","Manual":<DownloadIcon color="primary" style={{cursor: 'pointer'}} onClick={()=>{handleDownload('Supervisor Manual.pdf')}}/>},{"Sr No":"3","User":"Manager Role:How to Approve time booking done by Reportees","Manual":<DownloadIcon color="primary" style={{cursor: 'pointer'}} onClick={()=>{handleDownload('Manager Manual.pdf')}}/>},{"Sr No":"4","User":"Department SPOC role","Manual":<DownloadIcon color="primary" style={{cursor: 'pointer'}} onClick={()=>{handleDownload('Departmental SPOC Manual.pdf')}}/>},{"Sr No":"5","User":"Linkage SPOC role","Manual":<DownloadIcon color="primary" style={{cursor: 'pointer'}} onClick={()=>{handleDownload('Linkage SPOC Manual.pdf')}}/>},]}
              tableHeaderLabel={["Sr No_20","User_170","Manuals_30"]}
              TableRowHederAling="left"
              size="small"
              headerColor="#E6F2FF"
              className="custom-table"
              />
              </div>     
              <h5>Note: for file Download click on icon.</h5>
          </Grid>
      </Grid>
       </>
      )

      const renderDetails = () => (
      <>
      <Grid container spacing={0.5}>
          <Grid item xs={3} md={2}>
            <h5>Contact Us:</h5>
          </Grid>
          <Grid item xs={9} md={8}>
            <h5>If you have any queries feel free to get in touch with us</h5>
          </Grid>
      </Grid>
       <Grid container spacing={1}>
       <Grid item xs={2} md={2}></Grid>
       <Grid item md={6} lg={6} sm={12} xs={12} style={{  marginBottom: "10px" }}>
         <div className={styles.formDiv}> 
         {/* <Card /> */}
         <TableSimple
             tableColumnData={transformedData} 
             tableHeaderLabel={["Contact_40","Escalation_40"]}
             TableRowHederAling="center"
             size="small"
             headerColor="#E6F2FF"
             className="custom-table"
         />
         </div>
         </Grid>
       </Grid>
       </>
      )

    return(
        <>
        <div className={styles.container} style={{ boxSizing: "border-box" }}>
            <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

          <BackButton
            action="Home"
            handleClick={redirectToApplicationLandingPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Help" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
            <UserInfoPanel
              userInfo={[
                {
                  Name: "Aditya Mathur",
                  "SAP ID": 122355,
                  "BC No": "122355",
                  LOC: "Engineering and Research Center",
                },
              ]}
            />
          </div>
        </div>

        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
        >
          <CustomFormGroup header="Help" body="" />
          {renderManualDetails()}
          {renderDetails()}
          {/* {renderHTML()} */}
        </div>
   
        </div>
        </>
    )
}


  export default withAllowedOperationsProvider(
    ContactUs,
    RESOURCE_TYPE.PROJECT
  );
